(function () {
  $.validator.setDefaults({
    'errorPlacement': function (error, element) {
      var target;
      if (element.is('select')) {
        target = element.next();
        error.removeAttr('for');
      }
      if (element.is('input') && element.attr('type') === 'file') {
        target = element.next();
      }
      if (!target || target.length === 0) {
        target = element;
      }
      target.after(error);
      return true;
    },
    'invalidHandler': function(event, validator) {
      if((validator) && (validator.numberOfInvalids() > 0)) {
        notify('Please verify all field requirements.', 'error');
      }
    }
  });
})();
